<template>
  <section>
    <contact-page></contact-page>
    <submit-page></submit-page>
  </section>
</template>

<script>
import SubmitPage from '../../../components/submitPage.vue'
import ContactPage from './contactPage.vue'
export default {
  components: { SubmitPage, ContactPage },
  name: 'aboutContact',
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang='scss' scoped>
</style>
